<template>
    <div>
        <Spin fix v-show="isSpinShow" size="large" />
        <div>
            <input id="upload_file" type="file" style="display: none;" accept="image/*" name="file" @change="fileChange($event)">
            <div id="upload_warp_left" style="margin:10px" onclick="$('#upload_file').click();">
                <img style="width:200px;" :src="showImg">
            </div>
            <Button type="primary" long @click="commit">提交</Button>
            <div class="line" style="margin-left: -280px;margin-top: 85px;">
                <div class="cropper-content" style="margin-top:-60px;margin-left:260px;">
                    <div class="cropper">
                        <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType"
                            :info="true" :full="option.full" :canScale="true" :canMove="option.canMove" :canMoveBox="option.canMoveBox"
                            :original="option.original" :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth"
                            :autoCropHeight="option.autoCropHeight" :fixedBox="option.fixedBox" @realTime="realTime"
                            @imgLoad="imgLoad"></vueCropper>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        VueCropper
    } from 'vue-cropper';
    export default {
        props: {
            callBack: {
                type: Function
            }
        },
        name: "cameras-and-albums",
        components: {
            VueCropper
        },
        data() {
            return {
                isShowData: false,
                isSpinShow: false,
                isDisabled: true,
                isCommiting: false,
                height: document.body.clientHeight,
                width: document.body.clientWidth,
                showImg: require("../../assets/imgs/idcard.jpg"),
                previews: {},
                option: {
                    img: '',
                    full: false, //输出原图比例截图 props名full
                    outputType: 'png',
                    canMove: true,
                    original: false,
                    canMoveBox: true,
                    autoCrop: true,
                    autoCropWidth: 200,
                    autoCropHeight: 30,
                    canScale: true,
                    fixedBox: false
                }
            };
        },
        methods: {
            fileChange(param) {
                let that = this;
                if (param.target.files) {
                    // 压缩文件
                    lrz(param.target.files[0])
                        .then(function(rst) {
                            console.log(rst);
                            that.option.img = rst.base64;
                            //that.generalocr(rst.base64);
                        }).catch(function(error) {
                            //失败时执行
                        }).always(function() {
                            //不管成功或失败，都会执行
                        })
                };
            },
            generalocr(base64) {
                const signature = require('../../utils/signature.js');
                let param = signature.create_general_param(base64.split(";base64,")[1]);
                let that = this;
                that.isSpinShow = true;
                that.showImg = base64;
                that.isDisabled = true;
                that.isShowData = false;
                $.ajax({
                    url: "/api/generalOCR",
                    contentType: "application/json",
                    type: "post",
                    data: param,
                    dataType: "json",
                    success: function(receiveData) {
                        if (receiveData.ret != 0) {
                            that.$Notice.error({
                                title: "异常" + receiveData.ret,
                                desc: receiveData.msg
                            });
                            that.isSpinShow = false;
                            that.showImg = require("../../assets/imgs/idcard.jpg");
                            that.userData = {};
                            that.idCard = "";
                            return;
                        }
                        that.isSpinShow = false;
                        that.isDisabled = false;
                        that.isShowData = true;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                        that.isSpinShow = false;
                    }
                });
            },
            // 实时预览函数 
            realTime(data) {
                let that = this;
                this.$refs.cropper.getCropData((data) => {
                    that.showImg = data;
                    //that.generalocr(data);
                })
            },
            imgLoad(msg) {
                console.log('imgLoad')
            },
            commit(){
                this.generalocr(this.showImg);
            }
        }
    };
</script>

<style lang="less">
    .cropper-content {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        -webkit-justify-content: center;
        .cropper {
            width: 400px;
            height: 400px;
        }
    }

    .cropper-content {
        margin-left: 0;
    }
</style>
